import React, { Component, Fragment } from 'react';

import { graphql, QueryRenderer } from 'react-relay';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import {
  Grid,
  CircularProgress,
  Snackbar,
  SnackbarContent,
} from '@material-ui/core';

import environment from '../../environment';

import { Pickem, Complete, BackgroundImg } from '../../components';

import { useStyles } from './styles.js';

class PickemWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      snackbar: false,
      message: 'Please answer',
    };
  }

  componentDidMount() {}

  componentWillReceiveProps(nextProps) {}

  handleSanckbar = msg => {
    this.setState({
      snackbar: true,
      message: msg,
    });
  };

  render() {
    const { classes } = this.props;
    const page_bg_image = this.props.event.page_bg_image;
    const show_page_bg_image = this.props.event.show_page_bg_image;
    let query = graphql`
      query PickemWrapperQuery(
        $arguments: pickemInputType
        $next_arguments: pickemInputType
        $pickemAnswerArgument: guestPickemAnswerInputType
        $args: pickemGameQuestionAnswerInputType
      ) {
        getGuestGameQuestionAnswerCount(arguments: $args) {
          code
          message
          data {
            total_questions
            total_tiebreaker_questions
            total_answered_questions
            total_answered_tiebreaker_questions
            current_chapter_data {
              chapter_id
              number_of_questions
              number_of_tiebreaker_questions
              number_of_answered_questions
              number_of_answered_tiebreaker
              number_of_correct_answers
            }
          }
        }

        currentChapter: getPickemQuestionsData(arguments: $arguments) {
          code
          message
          data {
            _id
            game_id
            quarter_id
            question
            tiebreaker_question
            show_tiebreaker_question
            options {
              _id
              option
            }
            correct_answer
          }
        }

        nextChapter: getPickemQuestionsData(arguments: $next_arguments) {
          code
          message
          data {
            _id
            game_id
            quarter_id
            question
            tiebreaker_question
            show_tiebreaker_question
            options {
              _id
              option
            }
          }
        }

        getGuestPickemAnswers(pickemAnswerArgument: $pickemAnswerArgument) {
          code
          message
          data {
            _id
            event_id
            game_id
            guest_id
            question_id
            quarter_id
            is_correct_answer
            is_tiebreaker
            answer
          }
        }
      }
    `;

    return (
      <>
        <QueryRenderer
          environment={environment}
          variables={this.props.variables}
          query={query}
          render={({ error, props, retry }) => {
            if (error) {
              return <div>No records found</div>;
            } else if (props) {
              // If no questions, show default text
              if(props.currentChapter.data && props.currentChapter.data.length == 0){
                return (
                  <div className={classes.defaultText}>
                    {' '}
                    {`Questions for ${this.props.chapter.chapter_name}
                    will be uploaded soon. Please check back later!`}
                  </div>
                )
              }
              // If no questions in next chapter, do not show next button but let users submit
              let next_is_empty = false;
              if(!props.nextChapter || props.nextChapter.data.length == 0){
                next_is_empty = true;
              }
              return (
                <Grid>
                  <BackgroundImg page_bg_image={page_bg_image} show={show_page_bg_image} />
                  <Grid>
                    {!this.props.noTitle ? (
                      <h1 style={this.props.chapterStyle}>
                        {this.props.chapter.chapter_name}
                      </h1>
                    ) : (
                      ''
                    )}
                  </Grid>
                  <Grid>
                    <Pickem
                      variables={this.props.args}
                      //subtracting 1 from questions length
                      //questions have tiebreaker question included in the array
                      //Waste Management tournament does not have tiebreaker question hence
                      //submission is only allowed once
                      disableOptions={
                        this.props.client == 'WM'
                          ? props.currentChapter.data.length ==
                            props.getGuestPickemAnswers.data.length
                          : !this.props.chapter.active
                      }
                      //this is just for WM
                      showReturnHomeButton={
                        props.currentChapter.data.length ==
                        props.getGuestPickemAnswers.data.length
                      }
                      questions={props.currentChapter.data}
                      answers={props.getGuestPickemAnswers.data}
                      getGuestGameQuestionAnswerCount={
                        this.props.client == 'WM'
                          ? ''
                          : props.getGuestGameQuestionAnswerCount.data
                      }
                      handleSanckbar={this.handleSanckbar}
                      next_is_empty={next_is_empty}
                      {...this.props}
                    />
                  </Grid>
                </Grid>
              );
            } else {
              return <CircularProgress className={classes.progress} />;
            }
          }}
        />
        {/**Checking if all the questions have been answered */}
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={this.state.snackbar}
          onClose={() => {
            this.setState({ snackbar: false });
          }}
        >
          <SnackbarContent
            message={this.state.message}
            style={this.props.pickemAlert}
          />
        </Snackbar>
      </>
    );
  }
}

PickemWrapper.propTypes = {
  className: PropTypes.string,
};

export default withStyles(useStyles)(PickemWrapper);
